import type { ErrorEvent } from '@sentry/react'

// Errors from browser extensions / injected scripts only have `<anonymous>` frames, never a file from our bundle.
export const isBrowserExtensionSentryEvent = (event: ErrorEvent) => {
  const frames = (event.exception?.values ?? []).flatMap(
    (exception) => exception.stacktrace?.frames ?? []
  )

  return frames.length > 0 && frames.every((frame) => frame.filename === '<anonymous>')
}
